<template>
  <div class="contact-box">
    <div class="title">
      <p>请填写联系人{{index+1}}的相关信息</p>
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        label="真实姓名"
        required
        clearable
        input-align="right"
        v-model="params.name"
        @input="change"
        placeholder="请输入真实姓名"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        label="手机号码"
        required
        clearable
        input-align="right"
        v-model="params.mobile"
        @input="change"
        placeholder="请输入手机号码"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        label="电子邮箱"
        required
        clearable
        input-align="right"
        v-model="params.email"
        @input="change"
        placeholder="请输入电子邮箱"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        label="固定电话"
        input-align="right"
        clearable
        v-model="params.telephone"
        @input="change"
        placeholder="请输入固定电话"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        input-align="right"
        label="工作单位"
        clearable
        v-model="params.company"
        @input="change"
        placeholder="请输入工作单位"
      />
    </div>
    <div class="base-item">
      <p>通讯地址</p>
      <van-field
        class="input-item"
        type="textarea"
        clearable
        v-model="params.fullAddress"
        @input="change"
        placeholder="请输入通讯地址"
      />
    </div>
  </div>
</template>

<script>
import { Icon, Field, Cell } from "vant";
export default {
  data() {
    return {
      params: {
        name: "",
        mobile: "",
        email: "",
        telephone: "",
        company: "",
        fullAddress: ""
      }
    };
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    }
  },
  components: {
    [Field.name]: Field
  },
  methods: {
    change(value) {
      this.$emit("input", this.params);
      this.$emit("change", this.params);
    }
  },
  mounted() {
    this.params = this.value;
  }
};
</script>

<style lang="less" scoped>
.title {
  font-size: 14px;
  background: #f1f1f1;
  padding: 14px 0;
  margin-bottom: 20px;
  p {
    padding-left: 10px;
    border-left: 3px solid #228ccd;
  }
}
.contact-box {
  margin-top: 10px;
  margin-bottom: 20px;
}
.input-item {
  padding: 10px 0 16px 15px;
  border-bottom: 1px solid #efefef;
}
.contact-box /deep/.van-field__label{ width: 1.6rem;}
.base-item p{ font-size:15px; color: #333; margin-top: 20px; margin-left: 15px;}
</style>

